function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.764 1.708c.145.069.236.215.236.375v5.834c0 .16-.091.306-.236.375-.144.07-.316.05-.44-.05l-1.97-1.575H.834c-.23 0-.417-.187-.417-.417v-2.5c0-.23.187-.417.417-.417h1.52l1.97-1.575c.124-.1.296-.12.44-.05zM4.167 2.95L2.761 4.075c-.074.06-.166.092-.26.092H1.25v1.666H2.5c.094 0 .186.032.26.091L4.167 7.05v-4.1zM7.652 1.76c.162-.163.426-.163.589 0C9.1 2.62 9.583 3.785 9.583 5c0 1.216-.483 2.381-1.342 3.24-.163.163-.427.163-.59 0-.162-.162-.162-.426 0-.589.703-.703 1.098-1.656 1.098-2.65 0-.995-.395-1.949-1.098-2.652-.162-.163-.162-.427 0-.59zM6.18 3.23c.162-.162.426-.162.589 0 .469.47.732 1.105.732 1.768s-.263 1.299-.732 1.768c-.163.162-.427.162-.59 0-.162-.163-.162-.427 0-.59.313-.312.489-.736.489-1.178 0-.442-.176-.866-.488-1.178-.163-.163-.163-.427 0-.59z",
  clipRule: "evenodd"
});

var SvgIcVolume = function SvgIcVolume(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcVolume, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_volume.43394564.svg";
export { ForwardRef as ReactComponent };